import { FormikValues } from 'formik';

export const getInitialValues = (data: FormikValues) => {
  const { internal_notes, technical_issue, case_report_review } = data || {};
  return { internal_notes, technical_issue, case_report_review };
};
